import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { returnUrl: String, delay: { type: Number, default: 15000 } }

  connect() {
    this.timer = setTimeout(() => {
      window.location.href = this.returnUrlValue
    }, this.delayValue)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }
}
